export default __webpack_public_path__ + "static/media/4.c7310a94.jpg";